import React from 'react';
import { useContent } from '../../context/ContentContext';
import { DEFAULT_BELIEFS_VALUES, resolveBeliefsValues } from '../../data/beliefsValues';

export default function EditorPanelBeliefsValuesDetail() {
  const { getContent, setContentValue } = useContent();
  const values = resolveBeliefsValues(getContent);

  const saveItems = (items) => {
    setContentValue('beliefs.values.items', items);
  };

  const updateItem = (index, patch) => {
    saveItems(values.items.map((item, idx) => (idx === index ? { ...item, ...patch } : item)));
  };

  const removeItem = (index) => {
    if (values.items.length <= 1) {
      window.alert('You need at least one value.');
      return;
    }
    if (!window.confirm('Remove this value?')) return;
    saveItems(values.items.filter((_, idx) => idx !== index));
  };

  const addItem = () => {
    saveItems([
      ...values.items,
      {
        label: DEFAULT_BELIEFS_VALUES.items[0]?.label || 'Value:',
        text: DEFAULT_BELIEFS_VALUES.items[0]?.text || 'Description',
      },
    ]);
  };

  return (
    <div className="editor-panel__detail" onClick={(e) => e.stopPropagation()}>
      <p className="editor-panel__detail-lead">Edit each value&apos;s heading and paragraph below.</p>

      <label className="editor-panel__detail-label" htmlFor="beliefs-values-title">
        Section title
      </label>
      <input
        id="beliefs-values-title"
        type="text"
        className="editor-panel__detail-input"
        value={values.title}
        onChange={(e) => setContentValue('beliefs.values.title', e.target.value)}
      />

      <ul className="editor-panel__detail-list">
        {values.items.map((item, index) => (
          <li key={`beliefs-value-${index}`} className="editor-panel__detail-card">
            <div className="editor-panel__detail-card-head">
              <span className="editor-panel__detail-card-title">Value {index + 1}</span>
            </div>

            <label className="editor-panel__detail-label" htmlFor={`beliefs-value-${index}-label`}>
              Heading
            </label>
            <input
              id={`beliefs-value-${index}-label`}
              type="text"
              className="editor-panel__detail-input"
              value={item.label}
              onChange={(e) => updateItem(index, { label: e.target.value })}
            />

            <label className="editor-panel__detail-label" htmlFor={`beliefs-value-${index}-text`}>
              Description
            </label>
            <textarea
              id={`beliefs-value-${index}-text`}
              className="editor-panel__detail-textarea"
              rows={4}
              value={item.text}
              onChange={(e) => updateItem(index, { text: e.target.value })}
            />

            <div className="editor-panel__detail-btn-row">
              <button
                type="button"
                className="editor-panel__detail-btn editor-panel__detail-btn--danger"
                onClick={() => removeItem(index)}
              >
                Remove value
              </button>
            </div>
          </li>
        ))}
      </ul>

      <div className="editor-panel__detail-btn-row editor-panel__detail-btn-row--footer">
        <button type="button" className="editor-panel__detail-btn editor-panel__detail-btn--primary" onClick={addItem}>
          + Add value
        </button>
      </div>
    </div>
  );
}
